var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 397,
    viewBox: "0 0 358 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_1826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.93 4.49628L17.0539 86.7978C6.49043 92.7929 0 103.871 0 115.861L0 280.464C0 292.454 6.49043 303.532 17.0539 309.527L161.93 391.828C172.493 397.823 185.474 397.823 196.037 391.828L340.913 309.527C351.476 303.532 357.967 292.454 357.967 280.464V115.861C357.967 103.871 351.476 92.7929 340.913 86.7978L196.07 4.49628C185.507 -1.49876 172.493 -1.49876 161.93 4.49628Z",
    fill: "#FAFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.39 286.458V109.897L178.984 21.6006L23.5776 109.897L23.5776 286.458L178.984 374.722L334.39 286.458Z",
    fill: "#2C2C2C",
    stroke: "#48BA86",
    strokeWidth: 6.34555,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.182 71.9697L68.1824 135.015V135.569L179.182 198.126V71.9697Z",
    fill: "#D3EBE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.182 198.129V324.285L179.281 324.318L290.347 261.207V260.751L179.182 198.129Z",
    fill: "#5EBF94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.182 198.13L68.1824 135.573V261.143L179.182 198.13Z",
    fill: "#48BA86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1824 261.142V261.207L179.182 324.285V198.129L68.1824 261.142Z",
    fill: "#ADDBC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.413 134.986L179.182 198.194V71.9072L290.413 134.986Z",
    fill: "#86CCAC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_1826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 358,
    height: 396.357,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLogo);
export default __webpack_public_path__ + "static/media/big-logo.de0bf91e03d0b3ccaf3208561f4e9c84.svg";
export { ForwardRef as ReactComponent };